import { NJButton, NJText } from '@engie-group/fluid-design-system-react';
import { UMFormStyles, UMSelect, UMR } from '../../urbanmap/_components';
import { FAMILIES, type Family, type Plan, type Project } from './types';

export function ContextSets({ project, plan, families, canWrite, onUpdate, onOpenSet }: {
  project: Project; plan: Plan; families: Family[]; canWrite: boolean;
  onUpdate: (changes: Partial<Plan>) => void; onOpenSet: (family: Family, id: string) => void;
}) {
  return <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
    <UMFormStyles />
    {families.map((family) => <section key={family} style={{ borderBottom: `1px solid ${UMR.border}`, paddingBottom: 8 }}>
      <NJText scale="xs" style={{ margin: '0 0 4px' }}>{FAMILIES.find((f) => f.key === family)?.title}</NJText>
      <fieldset disabled={!canWrite} style={{ border: 0, margin: 0, padding: 0 }}>
        <UMSelect value={plan.setIds[family]} ariaLabel={`Jeu ${family}`} options={[
          ...project.sets[family].map((set) => ({ value: set.id, label: `${set.name} · v${set.version}` })),
          { value: '__create', label: 'Créer un nouveau…' },
        ]} onChange={(id) => id === '__create' ? onOpenSet(family, '__create')
          : onUpdate({ setIds: { ...plan.setIds, [family]: id } })} />
      </fieldset>
      <NJButton label="Consulter / gérer le jeu" scale="sm" variant="secondary" emphasis="minimal"
        onClick={() => onOpenSet(family, plan.setIds[family])} />
    </section>)}
  </div>;
}
